/** We are using this package for our slider :) */
import { palette } from '$tablet-app/src/app/theme';
import React, { FC } from 'react';
import { StyleSheet } from 'react-native';
import { Slider as PackageSlider, SliderProps } from 'react-native-elements';

const Slider: FC<SliderProps> = ({ ...props }) => {
  return (
    <PackageSlider
      thumbStyle={styles.thumb}
      thumbTintColor="white"
      minimumTrackTintColor={palette.primary_70} // The track color before the current value
      maximumTrackTintColor="grey"
      animateTransitions={true}
      {...props}
    />
  );
};

const styles = StyleSheet.create({
  thumb: {
    height: 48,
    width: 48,

    borderRadius: 86,

    borderWidth: 4,
    borderColor: palette.primary_70,
  },
});

export default Slider;
